export default "__VITE_ASSET__5c19e602__"